import React from "react";

/**
 * Top-level error boundary. Without one, any uncaught render error unmounts the
 * whole React tree and leaves a blank white page that only a manual reload
 * recovers (the "hangs / white screen, must close and reopen" reports). This
 * catches the error and shows a minimal, recoverable screen instead.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Uncaught render error:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "24px",
            textAlign: "center",
            fontFamily: "sans-serif",
          }}
        >
          <h2 style={{ margin: 0 }}>Es ist ein Fehler aufgetreten.</h2>
          <p style={{ margin: 0, color: "#555", maxWidth: "420px" }}>
            Bitte laden Sie die Seite neu. Ihre zuletzt gespeicherten Daten
            bleiben erhalten.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              background: "var(--main-color, #0d6efd)",
              color: "#fff",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
